import React, { FC } from 'react';
import { IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewWrapper from '../ReviewWrapper';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import ReviewText from '../ReviewText';
import { IGmbLocation } from '../../../shared/interfaces/IGmbLocation';
import GoogleLocationInfo from '../Elements/GoogleLocationInfo';

interface Props extends IReviewNewProps {
  locationId: string;
  location?: IGmbLocation[];
}

const GoogleReview: FC<Props> = ({
  locationId,
  commentingModule,
  communityManagement,
  location,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { rating, comment, reviewer, reviewReply, createTime, reviewId } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      subHeader={
        <GoogleLocationInfo
          locationId={reviewEntry.company}
          locations={location}
        />
      }
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {reviewer.displayName && reviewer.profilePhotoUrl && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Avatar
            alt={reviewer.displayName}
            src={reviewer.profilePhotoUrl}
            imgProps={{ referrerPolicy: 'no-referrer' }}
            sx={{ width: 32, height: 32, fontSize: '0.85rem' }}
          >
            {reviewer.displayName.charAt(0)}
          </Avatar>
          <Box>
            <Typography
              variant="body1"
              sx={{ ml: theme.spacing(1) }}
            >
              {reviewer.displayName}
            </Typography>
          </Box>
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          ></Typography>
        </Box>
      )}
      <ReviewText text={comment} />
    </ReviewWrapper>
  );
};

export default GoogleReview;
